<template>
  <div class="toast-wrapper" @click.self="close">
    <div class="toast-container">
      <div class="toast">
        <p><slot></slot></p>
        <span role="button" class="toast-close" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted, onUnmounted, watch } from '@vue/composition-api'

export default defineComponent({
  setup (props, context) {
    const store = context.root.$store
    const { common } = store.state

    const state = reactive({
      count: common.toast.time,
      timer: null
    })
    watch(
      () => state.count,
      (count, prevCount) => {
        (count === 0) && close()
      }
    )
    const close = () => {
      store.dispatch('common/hideToast')
      resetTimer()
    }

    onMounted(() => {
      state.timer = setInterval(() => state.count--, 1000)
    })

    onUnmounted(() => resetTimer())

    const resetTimer = () => {
      state.timer && clearInterval(state.timer)
      state.timer = null
    }
   
    return {
      close
    }
  }
})
</script>

<style lang="scss" scoped>
.toast-wrapper {
  position: fixed;
  z-index: $index-popup;
  background-color: rgba(0,0,0,.1);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  .toast-container {
    position: absolute;
    width: calc(100% - 20px);
    top: 16px;
    left: 0;
  }
  .toast {
    background-color: #fff;
    font-size: 1.6rem;
    padding: 12px 52px 12px 12px;
    border-radius: 0 4px 4px 0;
    color: $color-content;
    &-close {
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translate3d(0,-50%,0);
      .icn {
        color: $color-sup;
        font-size: 1.6rem;
      }
    }
  }
}
</style>
